"use strict";

var _interopRequireDefault = require("D:/CRM/Client2026/node_modules/@babel/runtime/helpers/interopRequireDefault.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.add = add;
exports.addItem = addItem;
exports.addSpecialApply = addSpecialApply;
exports.all = all;
exports.allByProductionOrder = allByProductionOrder;
exports.check = check;
exports.default = void 0;
exports.del = del;
exports.delSpecialApply = delSpecialApply;
exports.edit = edit;
exports.editItem = editItem;
exports.findById = findById;
exports.getCodeNumber = getCodeNumber;
exports.getNodeLists = getNodeLists;
exports.getSpecialApplyItemCode = getSpecialApplyItemCode;
exports.itemFindById = itemFindById;
exports.queryByComplete = queryByComplete;
exports.queryByOms = queryByOms;
exports.queryCmsSpecialApplyItem = queryCmsSpecialApplyItem;

var _request = _interopRequireDefault(require("@/utils/request"));

function add(data) {
  return (0, _request.default)({
    url: 'api/cmsSpecialApply',
    method: 'post',
    data: data
  });
}

function del(ids) {
  return (0, _request.default)({
    url: 'api/cmsSpecialApply',
    method: 'delete',
    data: ids
  });
}

function edit(data) {
  return (0, _request.default)({
    url: 'api/cmsSpecialApply',
    method: 'put',
    data: data
  });
}

function all() {
  return (0, _request.default)({
    url: 'api/cmsSpecialApply',
    method: 'get'
  });
}

function allByProductionOrder(data) {
  return (0, _request.default)({
    url: 'api/omsSpecialApply/all?productionOrder=' + data,
    method: 'get'
  });
}

function queryByOms(contractNumber) {
  return (0, _request.default)({
    url: 'api/cmsSpecialApply/queryByOms?contractNumber=' + contractNumber,
    method: 'get'
  });
}

function findById(rowId) {
  return (0, _request.default)({
    url: 'api/cmsSpecialApply?rowId=' + rowId,
    method: 'get'
  });
}

function getNodeLists(specialApplicationId) {
  return (0, _request.default)({
    url: 'api/cmsSpecialApply/getNodeLists?specialApplicationId=' + specialApplicationId,
    method: 'get'
  });
}

function getCodeNumber() {
  return (0, _request.default)({
    url: 'api/cmsSpecialApply/getCodeNumber',
    method: 'get'
  });
}

function queryByComplete() {
  return (0, _request.default)({
    url: 'api/cmsSpecialApply/queryByComplete',
    method: 'get'
  });
}

function addSpecialApply(data) {
  return (0, _request.default)({
    url: 'api/omsSpecialApply',
    method: 'post',
    data: data
  });
}

function delSpecialApply(ids) {
  return (0, _request.default)({
    url: 'api/omsSpecialApply',
    method: 'delete',
    data: ids
  });
}

function queryCmsSpecialApplyItem(specialApplyId) {
  return (0, _request.default)({
    url: 'api/cmsSpecialApplyItem/all?specialApplyId=' + specialApplyId,
    method: 'get'
  });
}

function getSpecialApplyItemCode(specialApplyCode) {
  return (0, _request.default)({
    url: 'api/cmsSpecialApplyItem/getCode?code=' + specialApplyCode,
    method: 'get'
  });
}

function addItem(data) {
  return (0, _request.default)({
    url: 'api/cmsSpecialApplyItem',
    method: 'post',
    data: data
  });
}

function check(data) {
  return (0, _request.default)({
    url: 'api/cmsSpecialApplyItem/check',
    method: 'put',
    data: data
  });
}

function editItem(data) {
  return (0, _request.default)({
    url: 'api/cmsSpecialApplyItem',
    method: 'put',
    data: data
  });
}

function itemFindById(rowId) {
  return (0, _request.default)({
    url: 'api/cmsSpecialApplyItem/findById?rowId=' + rowId,
    method: 'get',
    rowId: rowId
  });
}

var _default = {
  itemFindById: itemFindById,
  editItem: editItem,
  check: check,
  addItem: addItem,
  getSpecialApplyItemCode: getSpecialApplyItemCode,
  queryCmsSpecialApplyItem: queryCmsSpecialApplyItem,
  delSpecialApply: delSpecialApply,
  addSpecialApply: addSpecialApply,
  queryByOms: queryByOms,
  add: add,
  edit: edit,
  del: del,
  all: all,
  findById: findById,
  getNodeLists: getNodeLists,
  getCodeNumber: getCodeNumber,
  queryByComplete: queryByComplete,
  allByProductionOrder: allByProductionOrder
};
exports.default = _default;